import * as ActionCable from "@rails/actioncable"

export default ActionCable.createConsumer()
